import { Component, Input, OnInit } from '@angular/core';
import { MatSidenav } from 'src/app/core/core';
import { OktaAuthStateService } from '@okta/okta-angular';
import { ADPResourceService, SitefinityMenuItem, ADPComponentsModule } from 'digital-core';
import { PGHAppLoadService, PGHOktaService, StorageService } from 'src/app/core/core';
import { NavLists } from '../sidenav.component';
import { PROGRAMINFORMATION } from 'src/app/core/constants/feature-key.constants';
import { Router, RouterLinkActive, RouterLink } from '@angular/router';

import { MatNavList, MatListItem } from '@angular/material/list';
import { GtmClickDirective } from 'src/app/shared';
import { MatDivider } from '@angular/material/divider';

@Component({
    selector: 'app-logged-out-navlist',
    templateUrl: './logged-out-navlist.component.html',
    styleUrls: ['./logged-out-navlist.component.scss'],
    imports: [MatNavList, MatListItem, RouterLinkActive, GtmClickDirective, MatDivider, RouterLink, ADPComponentsModule]
})
export class LoggedOutNavlistComponent implements OnInit {
  @Input() isShowing: boolean;
  @Input() sidenavRef: MatSidenav;

  NavLists = NavLists;
  currentNavList: number = NavLists.root;
  programInfoLinks: SitefinityMenuItem[];
  headerLoggedOutSettings: SitefinityMenuItem[] = null;
  headerLoggedOutSettingsSaved: SitefinityMenuItem[] = null;
  isAuthenticated: boolean = false;
  userGivenName: string = '';
  isSRLoaded = false;
  languages: any;
  selectedLanguageKey: string = null;
  chooseLanguage: string = null;
  chooseLanguageTitle: string = null;


  constructor(
    private oktaAuth: OktaAuthStateService,
    private appLoadService: PGHAppLoadService,
    private resourceService: ADPResourceService,
    private storageService: StorageService,
    private pghOktaService: PGHOktaService,
    private router: Router,
  ) { }

  async ngOnInit(): Promise<void> {
    this.isAuthenticated = this.pghOktaService.isTokenValid();
    if (this.isAuthenticated) {
      this.pghOktaService.getUser().then(user => {
        this.userGivenName = user.given_name;
      });
    }

    this.oktaAuth.authState$.subscribe(authState => this.isAuthenticated = authState.isAuthenticated);
    this.appLoadService.isSiteResourcesLoaded.subscribe(value => {
      this.isSRLoaded = value;
      if (value) {
        this.getLanguages();
        this.resourceService.getPortalMenus('Header_LoggedOut_Nav_Menu').subscribe(data => {
          this.headerLoggedOutSettings = data.MenuItems;
          this.headerLoggedOutSettings = this.headerLoggedOutSettings.filter(x => x.Caption !== '_');
          this.headerLoggedOutSettingsSaved = JSON.parse(JSON.stringify(this.headerLoggedOutSettings));

          if (this.headerLoggedOutSettings?.length) {
            const programLinks = this.headerLoggedOutSettings.find(x => x.LinkUrl === PROGRAMINFORMATION);
            if (programLinks) {
              this.resourceService.getPortalMenus('Header_Program_Information_Child_Menu').subscribe(childData => {
                this.programInfoLinks = JSON.parse(JSON.stringify(childData.MenuItems));
                console.log(this.programInfoLinks);
              });
            }
          }
        });
      }
    });
  }

  showChildren(event: Event) {
    this.currentNavList = NavLists.claims;
    this.headerLoggedOutSettings = this.headerLoggedOutSettingsSaved.filter(x => x.LinkUrl === PROGRAMINFORMATION);
    event.stopPropagation();
  }

  programLinkClick(navigationItem: SitefinityMenuItem) {
    this.currentNavList = NavLists.root;
    this.headerLoggedOutSettings = JSON.parse(JSON.stringify(this.headerLoggedOutSettingsSaved));
    // open external links like FAQs in new window
    if (navigationItem?.LinkUrl.startsWith('http')) {
      window.open(navigationItem?.LinkUrl, '_blank');
    } else {
      this.router.navigate([navigationItem?.LinkUrl]);
    }
  }

  backClick(event: Event) {
    this.currentNavList = NavLists.root;
    this.headerLoggedOutSettings = JSON.parse(JSON.stringify(this.headerLoggedOutSettingsSaved));
    event.stopPropagation();
  }

  getSelectedLanguage() {
    return this.selectedLanguageKey || 'EN';
  }

  getLanguages() {
    let local = this.storageService.getLocal<string>(`language`);
    this.selectedLanguageKey = local ?? 'EN';
    let languages = this.resourceService.getListItemResource("Global_Languages");
    languages.subscribe((data) => {
      this.languages = data;
      const language = this.languages.find(x => x.Key.toLocaleLowerCase() === this.getSelectedLanguage().toLocaleLowerCase());
      this.selectedLanguageKey = language?.Key;
      this.chooseLanguage = this.languages.find(x => x.Key != this.selectedLanguageKey)?.Value;
      this.chooseLanguageTitle = this.resourceService.getViewLabel('Global_Language_Title') + this.chooseLanguage;
      if (!this.selectedLanguageKey) {
        this.storageService.setLocal(`language`, null);
        window.location.reload();
      }
    });
  }

  toggleLanguage() {
    const language = this.languages.find(x => x.Key.toLocaleLowerCase() != this.getSelectedLanguage().toLocaleLowerCase());
    this.storageService.setLocal<string>(`language`, language?.Key);
    window.location.reload();
  }
}
